import React from 'react'

type Props = {
    children?: React.ReactNode;
}

const ScrollableTable = (props: Props) => {
    return (
        <div className="w-full overflow-x-auto rounded-lg border-solid border-[1px] border-primary border-opacity-10 shadow-md">
            <table className="table-auto w-full text-center">
                {props.children}
            </table>
        </div>
    )
}

export default ScrollableTable